export enum GdkMiddlewareStep {
  NoPartnerCenterAccount = "NoPartnerCenterAccount",
  Unauthorized = "Unauthorized",
  MainRequest = "MainRequest",
  Submitting = "Submitting",
  Submitted = "Submitted",
}

export type GdkMiddlewareRequest = Readonly<{
  sellerId: string;
  middlewareId: string;
  email: string;
}>;
